export const WHATSAPP_META_UI_ENABLED = process.env.REACT_APP_WHATSAPP_META_UI_ENABLED === 'true';

const hiddenZapiUserIds = new Set(
  String(process.env.REACT_APP_WHATSAPP_ZAPI_HIDDEN_USER_IDS || '')
    .split(',')
    .map((value) => Number(value.trim()))
    .filter((value) => Number.isInteger(value) && value > 0),
);

export const isWhatsappZapiMenuHiddenForUser = (userId) => hiddenZapiUserIds.has(Number(userId));

// The same narrow allowlist identifies the isolated Meta-review experience.
// It keeps customer-specific onboarding/branding out of the reviewer account
// without changing the CRM seen by any other user.
export const isWhatsappMetaReviewerUser = (userId) => hiddenZapiUserIds.has(Number(userId));
